export default __webpack_public_path__ + "assets/images/9f8b33118aa1f9fc5ab8ac8528cd9ea7-no_animal_testing.svg";